import * as LOGIN_API from './login/index.js';
import * as PROJECT_API from './project/index.js';
import * as ATTENDANCE_API from './attendance/index.js';
import * as EMPLOYEE_API from './employee/index.js';

export default Object.assign(
  {},
  LOGIN_API,
  PROJECT_API,
  ATTENDANCE_API,
  EMPLOYEE_API
);
